import { render, staticRenderFns } from "./AddPhoneNumberModal.vue?vue&type=template&id=7276dce2&"
import script from "./AddPhoneNumberModal.vue?vue&type=script&lang=ts&"
export * from "./AddPhoneNumberModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7276dce2')) {
      api.createRecord('7276dce2', component.options)
    } else {
      api.reload('7276dce2', component.options)
    }
    module.hot.accept("./AddPhoneNumberModal.vue?vue&type=template&id=7276dce2&", function () {
      api.rerender('7276dce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/phone-number/AddPhoneNumberModal.vue"
export default component.exports